import ax from "./ax";

// 我的代理列表
export function GetMyAgentListForH5(data = {}) {
  return ax({
    url: "/app/Agent/" + PUBLIC_INTERFACE.GetMyAgentListForH5,
    method: "post",
    data
  });
}

// 代理商星级列表
export function GetAgentLevelListForH5(data = {}) {
  return ax({
    url: "/app/Agent/" + PUBLIC_INTERFACE.GetAgentLevelListForH5,
    method: "post",
    data
  });
}

// 代理商详情
export function GetAgentDetailsForH5(data = {}) {
  return ax({
    url: "/app/Agent/" + PUBLIC_INTERFACE.GetAgentDetailsForH5,
    method: "post",
    data
  });
}

// 我的代理列表（新）
export function GetMyAgentListForH5New(data = {}) {
  return ax({
    url: "/app/Agent/GetMyAgentListForH5New",
    method: "post",
    data
  });
}

// 我的代理列表（统计）
export function GetMyAgentDealH5(data = {}) {
  return ax({
    url: "/app/Agent/GetMyAgentDealH5",
    method: "post",
    data
  });
}

// 我的代理列表日期查询条件
export function DateBase(data = {}) {
  return ax({
    url: "/app/Agent/DateBase",
    method: "post",
    data
  });
}

// 获取商户列表V2
export function GetMyUserListV2(data = {}) {
  return ax({
    url: "/app/Agent/GetMyUserListV2",
    method: "post",
    data
  });
}

// 商户列表获取商户交易金额V2
export function GetMyUserMoneyListV2(data = {}) {
  return ax({
    url: "/app/Agent/GetMyUserMoneyListV2",
    method: "post",
    data
  });
}

// 获取商户详情
export function GetMyUserOne(data = {}) {
  return ax({
    url: "/app/Agent/GetMyUserOne",
    method: "post",
    data
  });
}

// 获取选定代理商的所有销售政策(不传则为自己的)
export function GetAgentAllSale(data = {}) {
  return ax({
    url: "/app/Agent/GetAgentAllSale",
    method: "post",
    data
  });
}

// 根据商户名称和手机号获取商户下拉框
export function GetUserListBox(data = {}) {
  return ax({
    url: "/app/Agent/GetUserListBox",
    method: "post",
    data
  });
}

// 根据商户名称和手机号获取商户下拉框
export function GetUserByMobileOrName(data = {}) {
  return ax({
    url: "/app/Agent/GetUserByMobileOrName",
    method: "post",
    data
  });
}

// 后台管理_代理商搜索下拉框
export function GetAgentListBox(data = {}) {
  return ax({
    url: "/app/Agent/GetAgentListBox",
    method: "post",
    data
  });
}

// 后台管理_代理商搜索下拉框
export function UserUpdateToAgent(data = {}) {
  return ax({
    url: "/app/Agent/UserUpdateToAgent",
    method: "post",
    data
  });
}

// 当前代理商流量费
export function GetUserFlowRateFee(data = {}) {
  return ax({
    url: "/app/Agent/GetUserFlowRateFee",
    method: "post",
    data
  });
}

// 获取代理商流量费列表
export function GetUserFlowRateFeeList(data = {}) {
  return ax({
    url: "/app/Agent/GetUserFlowRateFeeList",
    method: "post",
    data
  });
}

// 设置代理商流量费
export function SetUserFlowRateFee(data = {}) {
  return ax({
    url: "/app/Agent/SetUserFlowRateFee",
    method: "post",
    data
  });
}

// 获取比较下级代理商流量费最大金额提示信息
export function GetUserMaxFlowRateFeeMsg(data = {}) {
  return ax({
    url: "/app/Agent/GetUserMaxFlowRateFeeMsg",
    method: "post",
    data
  });
}
//查询奖励列表
export function ShowTaskRewardLogList(data = {}) {
  return ax({
    url: "/app/Agent/ShowTaskRewardLogList",
    method: "post",
    data
  });
}
//查询奖励详情
export function ShowTaskRewardLogListMember(data = {}) {
  return ax({
    url: "/app/Agent/ShowTaskRewardLogListMember",
    method: "post",
    data
  });
}